import styles from "./index.module.scss";

interface RangeSliderProps {
	value: number;
	min: string;
	max: string;
	onChange: (e: any) => void;
	className?: string;
	style?: React.CSSProperties;
}

export default function RangeSlider({
	value,
	min,
	max,
	onChange,
	className,
	style,
}: RangeSliderProps) {
	return (
		<input
			type="range"
			min={min}
			max={max}
			value={value}
			onChange={onChange}
			className={`${styles.range} ${className}`}
			style={style}
		/>
	);
}
